import services from "../services";
import * as types from "./mutation-type";

export const setPurchases = ({ commit }, payload) => {
    commit(types.SET_PURCHASES, payload);
};

export const setPagination = ({ commit }, payload) => {
    commit(types.SET_PAGINATION, payload);
};

export const getPurchases = ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getPurchases(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};
